import { Injectable } from '@angular/core';
import { Response } from "@angular/http";

import "rxjs/Rx";
import { Subject } from "rxjs/Subject";
import { AuthHttp } from "angular2-jwt";
import { environment } from "../../../../environments/environment";

@Injectable()
export class PersonPhotoService {

    personPhotoChanged = new Subject();

    constructor(private authHttp: AuthHttp) { }

    private errorMessage: string = null;
    hasErrors() {
        return this.errorMessage != null;
    }
    getErrorMessage() {
        return this.hasErrors() ? this.errorMessage : "";
    }

    private personPhoto: string;

    loadPersonPhoto(clientId: number) {
        this.errorMessage = null;

        const qs = environment.apiPath + '/api/Enforcement/GetPersonPhoto?clientId=' + clientId;

        return this.authHttp.get(qs)
            .map(
            (response: Response) => {
                return response.json();
            }).subscribe(
            (response: any) => {
                if (response.responseInfo.isError) {
                    this.personPhoto = null;
                    this.errorMessage = response.responseInfo.message;
                } else {
                    this.personPhoto = response;
                    this.errorMessage = null;
                }

                this.personPhotoChanged.next();
            },
            (error) => {
                this.errorMessage = error;
                this.personPhotoChanged.next();
            });
    }

    getPersonPhoto() {
        return this.personPhoto;
    }

    init() {
        this.personPhoto = null;
    }
}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/services/nonanon/person/person-photo.service.ts